Ext.define('SA.EditLocationRequiredRule', {
    constructor(model) {
        this.model = model;
    },

    getMessage() {
        return !this.model.getProject().hasLocations()
            ? 'Please add a location to the project.'
            : 'Please select a location to view the report.';
    },

    isBroken() {
        return this.model.getLocations().length === 0;
    }
});